import { render, staticRenderFns } from "./Renjiadao.vue?vue&type=template&id=00d00e7e&scoped=true&"
import script from "./Renjiadao.vue?vue&type=script&lang=js&"
export * from "./Renjiadao.vue?vue&type=script&lang=js&"
import style0 from "./Renjiadao.vue?vue&type=style&index=0&id=00d00e7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d00e7e",
  null
  
)

export default component.exports